/** @jsxImportSource @emotion/react */
import withCommonSnapshotsOnly from '@signal/hoc/withCommonSnapshotsOnly'
import { MultiAppMenuPanelPropsType } from '../MultiAppMenuPanel/types'
import { memo } from 'react'
import {
  InnerWrapper,
  LogoWrapper,
  OuterWrapper,
  MenuWrapper,
  ToggleButton,
  SkeletonBottomSection,
  SkeletonMenuItems,
  SkeletonMenuRow,
  SkeletonSearchWrapper
} from './styles'
import { getMenuExpandedMode, getMenuPanelWidth } from '@signal/layouts/utils'
import TenantMenu from '../TenantMenu'
import TypographySkeleton from '../Skeleton/Typography'

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function Skeleton(_: MultiAppMenuPanelPropsType) {
  const isExpanded = getMenuExpandedMode()
  const rowCount = isExpanded ? 7 : 8

  return (
    <OuterWrapper
      $isExpanded={isExpanded}
      $menuPanelWidth={getMenuPanelWidth()}
    >
      <InnerWrapper
        $isExpanded={isExpanded}
        $menuPanelWidth={getMenuPanelWidth()}
      >
        <LogoWrapper $isExpanded={isExpanded}>
          <TenantMenu compact={!isExpanded} />
        </LogoWrapper>

        {isExpanded && (
          <SkeletonSearchWrapper>
            {/* @ts-ignore */}

            <TypographySkeleton variant="h1" width={210} />
          </SkeletonSearchWrapper>
        )}

        <MenuWrapper $isExpanded={isExpanded}>
          <SkeletonMenuItems $isExpanded={isExpanded}>
            {/* // eslint-disable-next-line @typescript-eslint/no-unused-vars */}
            {Array.from({ length: rowCount }).map((_, index) => (
              <SkeletonMenuRow
                key={`left-menu-skeleton-row-${index}`}
                $isExpanded={isExpanded}
              >
                {/* @ts-ignore */}
                <TypographySkeleton
                  variant={isExpanded ? 'h1' : 'h2'}
                  // @ts-ignore
                  width={isExpanded ? 54 : 24}
                />
                {isExpanded && (
                  // @ts-ignore
                  <TypographySkeleton variant="h2" width={150} lines={2} />
                )}
              </SkeletonMenuRow>
            ))}
          </SkeletonMenuItems>

          <SkeletonBottomSection $isExpanded={isExpanded}>
            {/* @ts-ignore */}
            <TypographySkeleton
              variant="h4"
              // @ts-ignore
              width={isExpanded ? 200 : 24}
              last={isExpanded ? 75 : 20}
              lines={isExpanded ? 2 : 1}
            />
          </SkeletonBottomSection>
        </MenuWrapper>

        <ToggleButton
          title={isExpanded ? 'Collapse menu' : 'Expand menu'}
          aria-label={isExpanded ? 'Collapse menu' : 'Expand menu'}
          disabled
        >
          {isExpanded ? '‹' : '›'}
        </ToggleButton>
      </InnerWrapper>
    </OuterWrapper>
  )
}

export default memo(withCommonSnapshotsOnly(Skeleton))
